import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ConsentService {
  private readonly root = `${environment.services.mpsrApi.url}/consent`;

  constructor(private http: HttpClient) {
  }

  recordConsent(userData: { phoneNumber: number;
    hasAcceptedConsent: boolean; }) {
    return this.http.post(`${this.root}`, userData);
  }

}
